module.exports = __webpack_public_path__ + "img/crypto-sol.346a52bf.svg";